<script>
  import { MultiSelect } from "carbon-components-svelte";
  export let onchange = () => {};
  export let labelText = "Title";
  export let label = "Select Item";
  export let selectionLabel = "";
  export let items = [];
  export let selectedIds = [];

  let selected = [];
  const handleChange = (e) => {
    selected = e.detail.selected;
    onchange(e);
  };
  $: selected;
</script>

<!-- Wrapper keeps the styles below from leaking into every list box of the app. -->
<div class="pax-multiselect">
  <MultiSelect
    {...$$restProps}
    bind:selectedIds
    on:select={handleChange}
    titleText={labelText}
    label={selectionLabel || (selected?.length === 0 ? label : selected.map((d) => d.text))}
    {items}
  />
</div>

<style>
  .pax-multiselect :global(.bx--list-box) {
    border: 1px solid var(--pax-black) !important;
    border-radius: 5px !important;
  }
  .pax-multiselect :global(.bx--tag--filter) {
    display: none !important;
  }
</style>
